import React from 'react';
import WasteManagement from '../Components/Solutions/WasteManagement';
import MarketSolutions from '../Components/Solutions/Market';
import BusinessModels from '../Components/Solutions/BusinessModels';
import Explore from '../Components/Solutions/Explore';

export default function Solutions() {
  return (
    <div className="solutions">
      <WasteManagement />
      <BusinessModels />
      <Explore />
      <MarketSolutions />
    </div>
  );
}
